import axios from "axios";

// API Base endpoint for local and live
const api = axios.create({
   //baseURL: "http://localhost:7045/api/v1",
   baseURL: "https://backend.argone.ng/api/v1",
  // baseURL:"https://test.argone.ng/api/v1",
  // baseURL: "https://argoneworlduserbackend.findfood.ng/api/v1",
  withCredentials: true, // Enable sending cookies with requests
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request interceptor to add token to headers
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const userState = localStorage.getItem('recoil-persist');
    if (userState) {
      try {
        const parsedState = JSON.parse(userState);
        const token = parsedState?.currentUserState?.data?.token;
        
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('Error parsing user state:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token refresh or errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('recoil-persist');
      window.location.href = '/admin-login';
    }
    return Promise.reject(error);
  }
);

export default api;
